module.exports = __webpack_public_path__ + "248a41148f9962774d15d2ef181b8aeb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-18.png
// module id = 1787
// module chunks = 0